import { LineReadable } from "./line-readable";
import { Vec } from "./vec";
import { VecLike } from "./vec-like";

export class Line<Point extends Vec> extends LineReadable<Point>{
	public constructor(
		a:Point,
		b:Point,
	){
		super(a,b);
	}

	public clone():this{
		return new (<any>this.constructor)(this.a.clone(),this.b.clone());
	}

	public set(a:Point, b:Point){
		this.a=a;
		this.b=b;
		return this;
	}

	public copy(that:{a:VecLike,b:VecLike}){
		this.a.copy(that.a);
		this.b.copy(that.b);
		return this;
	}
	
	public reverse(){
		[this.a,this.b]=[this.b,this.a];
		return this;
	}

	public translate(delta:VecLike){
		this.a.add(delta);
		this.b.add(delta);
		return this;
	}

	public frwd(){
		return this.b.delta(this.a).nrm();
	}
}

export namespace Line{
	export const Intersection=LineReadable.Intersection;
	export type Intersection=LineReadable.Intersection;
}